<template lang="pug">
.generic-wrapper
  .container
    h1.title Website verwalten
    .sub-headline Fügen Sie neue Seiten hinzu oder verändern Sie bestehende.

    MenuItems
      MenuItem(name="Tagestipps" description="Erstellen Sie neue oder verändern Sie Tagestipps." @click="$router.push({name: 'CMSDailyTips'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            polyline(points='20 12 20 22 4 22 4 12')
            rect(x='2' y='7' width='20' height='5')
            line(x1='12' y1='22' x2='12' y2='7')
            path(d='M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z')
            path(d='M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z')
      MenuItem(name="Angebote" description="Erstellen Sie neue oder verändern Sie bestehende Angebote." @click="$router.push({name: 'CMSPromotions'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            polyline(points='20 12 20 22 4 22 4 12')
            rect(x='2' y='7' width='20' height='5')
            line(x1='12' y1='22' x2='12' y2='7')
            path(d='M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z')
            path(d='M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z')
      MenuItem(name="Seiten" description="Verwalten Sie alle Seiten Ihrer Webseite." @click="$router.push({name: 'CMSBlocks'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            rect(x='3' y='3' width='18' height='18' rx='2' ry='2')
            line(x1='3' y1='9' x2='21' y2='9')
            line(x1='9' y1='21' x2='9' y2='9')
      MenuItem(name="Medien" description="Verwalten Sie alle Medien Ihrer Webseite." @click="$router.push({name: 'CMSMedias'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            rect(x='3' y='3' width='18' height='18' rx='2' ry='2')
            circle(cx='8.5' cy='8.5' r='1.5')
            polyline(points='21 15 16 10 5 21')
      MenuItem(name="Komponenten" description="Verwalten Sie alle Komponenten Strukturen für Ihre Webseite." @click="$router.push({name: 'CMSBlockModels'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            line(x1='8' y1='6' x2='21' y2='6')
            line(x1='8' y1='12' x2='21' y2='12')
            line(x1='8' y1='18' x2='21' y2='18')
            line(x1='3' y1='6' x2='3.01' y2='6')
            line(x1='3' y1='12' x2='3.01' y2='12')
            line(x1='3' y1='18' x2='3.01' y2='18')

</template>

<script>
import MenuItem from "@/components/atoms/MenuItem.vue";
import MenuItems from "@/components/molecules/MenuItems.vue";

export default {
  components: {
    MenuItem,
    MenuItems
  }
};
</script>